import {MotorModelList} from "./MotorModelList";
import {MotorModelEdit} from "./MotorModelEdit";
import {MotorModelCreate} from "./MotorModelCreate";

export default {
    list: MotorModelList,
    create: MotorModelCreate,
    edit: MotorModelEdit
};
